import { ResponseActionTypes, ResponseState } from 'types';
import { Reducer } from 'redux';

const initialState: ResponseState = {
  loadingResponseAttachments: false,
  responseAttachmentsData: undefined,
  errorResponseAttachments: undefined,
  loadingDownloadLink: false,
  downloadLink: undefined,
  errorDownloadLink: undefined,
  loadingDownloadAll: false,
  downloadAll: undefined,
  errorDownloadAll: undefined
};

const reducer: Reducer<ResponseState> = (state = initialState, action: any) => {
  switch (action.type) {
    case ResponseActionTypes.FETCH_RESPONSE_ATTACHMENTS_START: {
      state = {
        ...state,
        loadingResponseAttachments: true
      };

      return state;
    }

    case ResponseActionTypes.FETCH_RESPONSE_ATTACHMENTS_SUCCESS: {
      state = {
        ...state,
        loadingResponseAttachments: false,
        responseAttachmentsData: action.payload
      };

      return state;
    }

    case ResponseActionTypes.FETCH_RESPONSE_ATTACHMENTS_FAILURE: {
      state = {
        ...state,
        loadingResponseAttachments: false,
        errorResponseAttachments: action.payload
      };

      return state;
    }

    case ResponseActionTypes.GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_START: {
      state = {
        ...state,
        loadingDownloadLink: true
      };

      return state;
    }

    case ResponseActionTypes.GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_SUCCESS: {
      state = {
        ...state,
        loadingDownloadLink: false,
        downloadLink: action.payload
      };

      return state;
    }

    case ResponseActionTypes.GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_FAILURE: {
      state = {
        ...state,
        loadingDownloadLink: false,
        errorDownloadLink: action.payload
      };

      return state;
    }

    case ResponseActionTypes.GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_START: {
      state = {
        ...state,
        loadingDownloadAll: true
      };

      return state;
    }

    case ResponseActionTypes.GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_SUCCESS: {
      state = {
        ...state,
        loadingDownloadAll: false,
        downloadAll: action.payload
      };

      return state;
    }

    case ResponseActionTypes.GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_FAILURE: {
      state = {
        ...state,
        loadingDownloadAll: false,
        errorDownloadAll: action.payload
      };

      return state;
    }

    default:
      return state;
  }
};

export { reducer as ResponseReducer };
